// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fKibL","rowOne":"styles_rowOne__OIjbE","rowTwo":"styles_rowTwo__fjrIS"};